import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const HomeHeroesService = {
  async getHomeHeroes() {
    let response = await $axios.get($api("home_heroes")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : null,
      status: response?.status,
    };
  },

  async createHomeHeroes(payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("home_heroes"),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateHomeHeroes(id: number, payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("home_heroes_id", { id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteHomeHeroes(id: number) {
    try {
      const { data, status } = await $axios.delete(
        $api("home_heroes_id", { id }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
